export interface JwtClaims {
  uid: string;
  usr: string;
  fname: string;
  lname: string;
  role: string;
  roleId: string;
  sub: string;
  exp: number;
  iat: number;
}

export function decodeJwt(token: string): JwtClaims | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = parts[1];
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decoded) as JwtClaims;
  } catch {
    return null;
  }
}

export function isTokenExpired(token: string, bufferSeconds = 0): boolean {
  const claims = decodeJwt(token);
  if (!claims) return true;
  return Date.now() / 1000 >= claims.exp - bufferSeconds;
}
